"use client";

import { useSearchParams } from "next/navigation";

/** Preserve the reader's unpersonalized Browse choice through a GET search. */
export function SearchViewField() {
    const params = useSearchParams();
    return params.get("view") === "all" ? <input type="hidden" name="view" value="all" /> : null;
}
